<template>
  <b-container fluid class="h-100-trim-header-footer mb-5" id="tailie-size">
    <b-row>
      <b-col id="tailie-agree-terms">
        <div id="tailie-terms">
          <!--suppress XmlDuplicatedId -->
          <p v-if="this.shouldAccept">
            {{ hey }} {{ firstName }}, {{ updated }} {{ privacyPolicyTitle }}
          </p>
          <!--suppress XmlDuplicatedId -->
          <p v-else class="font-weight-bold">
            {{ privacyPolicyTitle }}
          </p>
          <nl2br tag="p" :text="privacyPolicy.text" class-name="tailieText" />
        </div>
      </b-col>
    </b-row>
    <b-row v-if="this.shouldAccept">
      <b-col>
        <div class="tailie-checkbox">
          <b-checkbox v-model="agreed" />
          <p class="tailie-termsofuse-checkbox">
            {{ agreeMessage }} {{ privacyPolicyTitle }}
          </p>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <!--suppress XmlDuplicatedId -->
        <b-button
          v-if="this.shouldAccept"
          id="tailie-terms-confirm"
          variant="primary"
          @click="agree"
        >
          {{ agreedText }}
        </b-button>
        <!--suppress XmlDuplicatedId -->
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import Nl2br from "vue-nl2br";

export default {
  name: "legal-privacy-policy",
  components: {
    Nl2br
  },
  data() {
    return {
      privacyPolicyTitle: "Privacy Policy",
      hey: "Hey",
      updated: "we've updated our",
      agreeMessage: "I have read and agree to the",
      agreed: null,
      agreedText: "I agree",
      returnText: "Return"
    };
  },
  props: {
    shouldAccept: Boolean
  },
  created() {
    if (this.shouldAccept) {
      this.$store.dispatch("users/getMe");
    }
    this.$store.dispatch("privacyPolicy/getLatestPrivacyPolicy");
  },
  computed: {
    ...mapGetters({
      firstName: "users/getSelfFirstName",
      privacyPolicy: "privacyPolicy/getLatestPrivacyPolicy"
    })
  },
  methods: {
    agree(evt) {
      evt.preventDefault();
      if (this.agreed) {
        this.$store
          .dispatch("privacyPolicy/confirm", this.privacyPolicy._id)
          .then(() => this.$router.go(-1));
      }
    }
  }
};
</script>
